module.exports = __webpack_public_path__ + "img/back-icon-mobile.fa3bfc55.svg";